// Javascript Dependecies
import Vue from "vue";
import VueRouter from "vue-router";
import api from "services/account";
import store from "./vuex/store";
import menuModule from "vuex-store/modules/menu";
import { EventBus } from "./event-bus";
import lazyLoading from "./vuex/store/modules/menu/lazyLoading";

// Lazyloading Views...

// Backend views

const AdminLayout = () => import(/* webpackChunkName: "group-admin" */ './admin/views/Layouts/App')
const AdminConnection = () => import(/* webpackChunkName: "group-admin" */ './admin/views/Connection')
const DashboardCandidates = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Candidates')
const DashboardSchedules = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/ApplicationsToScheduleList')
const DashboardDocuments = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Documents')
const DashboardNotifications = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Notifications')
const DashboardAppointments = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Appointments')
const DashboardMessages = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Messages')
const DashboardTasks = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Tasks')
const DashboardAccountingBalances = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Balances')
const DashboardCodesBourse = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/CodesBourse')

const DashboardChangeRequests = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/ChoiceChangeRequests')

const EditCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AccountCandidate')
const AccountsList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AccountsList')
const EditPaymentsCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/orders/Orders')
const EditCreditsCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/credits/Credits')
const AddCandidateOffers = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/offers/Index')
const SchoolCandidateOffers = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/offers/Offers')
const EditFinanceCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/AccountCandidate')
const PaymentsList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsList')
const PaymentsCheckList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsCheckList')
const PaymentsCashFlow = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsCashFlow')
const TotalCashFlow = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/TotalCashFlow')
const ReminderList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/ReminderList')
const AttendantList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AttendantList')
const EditDocument = () => import(/* webpackChunkName: "group-admin" */ './admin/views/documents/Document')
const EditTraining = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Training')
const ImportTrainingDates = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/ImportDates')
const ImportTrainingCapacities = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/ImportCapacities.vue')
const EditOffer = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/OfferForm.vue')
const EditOfferCategory = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/CategoryForm.vue')
const EditPromoCode = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/PromoCodeForm.vue')
const EditSchool = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/School')
const EditCampus = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Campus')
const EditEvent = () => import(/* webpackChunkName: "group-admin" */ './admin/views/events/Event')
const Stats = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Stats')


// Common schools pages
const MainLayout = () => import(/* webpackChunkName: "group-schools" */ './components/layouts/main')
const Jpo = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpo')

const Webinaire = () => import(/* webpackChunkName: "group-schools" */ './components/pages/webinaire')
const Atelier = () => import(/* webpackChunkName: "group-schools" */ './components/pages/atelier')
const JpoLive = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpoLive')
const JpoDoc = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpoDoc')
const Contact = () => import(/* webpackChunkName: "group-schools" */ './components/pages/contact')
const Process = () => import(/* webpackChunkName: "group-schools" */ './components/pages/admissionProcess')
const Connection = () => import(/* webpackChunkName: "group-schools" */ './components/login/connection')
const Registration = () => import(/* webpackChunkName: "group-eschool" */ './components/login/registration')
const ResetPassword = () => import(/* webpackChunkName: "group-schools" */ './components/login/resetPassword')
const NotFoundPage = () => import(/* webpackChunkName: "group-schools" */ './components/errors/404')

// Highschool views
const Home = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/home')
const HighSchoolApplication = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/application')
const Contract = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/scholarContract')


// School views
const SchoolHome = () => import(/* webpackChunkName: "group-school" */ './school/views/pages/home')
const SchoolApplication = () => import(/* webpackChunkName: "group-school" */ './school/views/pages/application')
const SchoolProfile = () => import(/* webpackChunkName: "group-school" */ './school/views/pages/profile')
const SchoolContract = () => import(/* webpackChunkName: "group-school" */ './school/views/pages/suisseContract')

// Shop views
const ShopHome = () => import(/* webpackChunkName: "group-school" */ './offers/views/pages/offers')
const ShopInternship = () => import(/* webpackChunkName: "group-school" */ './offers/views/pages/internships')
const ShopConnection = () => import(/* webpackChunkName: "group-school" */ './offers/views/pages/connection')

// Echool views
const EschoolHome = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/home')
const EschoolApplication = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/application')
const EschoolProfile = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/profile')
const EschoolContract = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/scholarContract')
const EshopHome = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/offers')
const EshopInternship = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/internships')
const EshopConnection = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/connection')



Vue.use(VueRouter);

// Add this before the routes definition
const boardingSchoolRedirectRoute = {
  path: '/admissionsco/:pathMatch(.*)*',
  redirect: to => {
    // Remove /admissionsco and replace with /admissionsup
    const newPath = '/admissionsup' + to.path.substring('/admissionsco'.length);
    return {
      path: newPath,
      query: to.query
    };
  }
};

// Add this before the routes definition
const boardingSchoolAliasRedirectRoute = {
  path: '/admissionboardingschool/:pathMatch(.*)*',
  redirect: to => {
    // Remove /admissionboardingschool and replace with /admissionsup
    const newPath = '/admissionsup' + to.path.substring('/admissionboardingschool'.length);
    return {
      path: newPath,
      query: to.query
    };
  }
};

// List of All Routes in Your Application
const routes = [
  boardingSchoolRedirectRoute,
  boardingSchoolAliasRedirectRoute,
  {
    path: "/admin",
    component: AdminLayout,
    meta: {
      isAdmin: true
    },
    children: [
      {
        path: "/admin/dashboard/candidats",
        component: DashboardCandidates,
        name: "dashboard-candidates",
        meta: {
          label: "Liste",
          title: "Liste des candidats",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/dashboard/schedules",
        component: DashboardSchedules,
        name: "dashboard-schedules",
        meta: {
          label: "Relances",
          title: "Gestion des relances",
          permissions: "manage schedules"
        }
      },
      {
        path: "/admin/dashboard/tasks/staff",
        component: DashboardTasks,
        name: "dashboard-staff-tasks",
        meta: {
          label: "Mes Tâches",
          title: "Tâches à éffectuer",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/codes-bourse",
        component: DashboardCodesBourse,
        name: "dashboard-codes-bourse",
        meta: {
          label: "Codes bourses",
          title: "Derniers codes bourses utilisés",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/choice-change-requests",
        component: DashboardChangeRequests,
        name: "choice-change-requests",
        meta: {
          label: "Demandes de changement",
          title: "Demandes de changement de choix",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/tasks",
        component: DashboardTasks,
        name: "dashboard-tasks",
        meta: {
          label: "Tâches",
          title: "Toutes les tâches",
          permissions: "access all tasks"
        }
      },
      {
        path: "/admin/dashboard/accounting/balances",
        component: DashboardAccountingBalances,
        name: "dashboard-accounting-balances",
        meta: {
          label: "Balances",
          title: "Balances client",
          permissions: "access cashflow accountability"
        }
      },
      {
        path: "/admin/dashboard/documents",
        component: DashboardDocuments,
        name: "dashboard-documents",
        meta: {
          label: "Liste",
          title: "Documents des candidats",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/dashboard/notifications",
        component: DashboardNotifications,
        name: "dashboard-notifications",
        meta: {
          label: "Liste",
          title: "Notifications",
          permissions: "list monitored"
        }
      },
      {
        path: "/admin/dashboard/appointments",
        component: DashboardAppointments,
        name: "dashboard-appointments",
        meta: {
          label: "Liste",
          title: "Rendezvous"
        }
      },
      {
        path: "/admin/dashboard/messages/:type",
        component: DashboardMessages,
        name: "dashboard-messages",
        meta: {
          label: "Liste",
          title: "Messages",
          permissions: "list candidates"
        }
      },

      {
        path: "/admin/candidat/:userId/edit",
        component: EditCandidate,
        name: "edit-candidate",
        meta: {
          label: "Edition",
          title: "Editer un candidat",
          permissions: "create candidate"
        }
      },
      {
        path: "/admin/candidat/:userId/paiements",
        component: EditPaymentsCandidate,
        name: "edit-payments-candidate",
        meta: {
          label: "Règlement",
          title: "Règlement et historique",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/candidat/:userId/offres",
        component: AddCandidateOffers,
        name: "add-candidate-offers",
        meta: {
          label: "Offres",
          title: "Ajouter une offre",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/candidat/:userId/offres/:school",
        component: SchoolCandidateOffers,
        name: "school-offers",
        meta: {
          label: "Offres",
          title: "Ajouter une offre",
          permissions: "list offers"
        },
        children: [
          {
            path: "categorie/:categoryId",
            component: SchoolCandidateOffers,
            name: "admin-shop-category",
            meta: {
              permissions: "list offers"
            },
          },
          {
            path: "categorie/:categoryId/:offerId",
            component: SchoolCandidateOffers,
            name: "admin-shop-offer",
            meta: {
              permissions: "list offers"
            },
          },
        ]
      },
      {
        path: "/admin/accounts/liste",
        component: AccountsList,
        name: "list-accounts",
        meta: {
          label: "Liste des candidats",
          title: "Comptes"
        }
      },
      {
        path: "/admin/finance/:userId/edit",
        component: EditFinanceCandidate,
        name: "edit-finance-candidate",
        meta: {
          label: "Edition",
          title: "Editer un candidat",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finance/:userId/credits",
        component: EditCreditsCandidate,
        name: "edit-credits-candidate",
        meta: {
          label: "Avoirs",
          title: "Avoirs",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/finances/:type",
        component: PaymentsList,
        name: "payments-list",
        meta: {
          label: "Liste",
          title: "Liste des paiements",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finances/checks/:status",
        component: PaymentsCheckList,
        name: "payments-checks",
        meta: {
          label: "Liste",
          title: "Liste des paiements",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finances/total/cashflow",
        component: TotalCashFlow,
        name: "total-cashflow",
        meta: {
          label: "Liste",
          title: "Trésorerie",
          permissions: "access cashflow"
        }
      },
      {
        path: "/admin/finances/cashflow/:status",
        component: PaymentsCashFlow,
        name: "payments-cashflow",
        meta: {
          label: "Liste",
          title: "Trésorerie",
          permissions: "access cashflow"
        }
      },
      {
        path: "/admin/relances/:status",
        component: ReminderList,
        name: "reminder-list",
        meta: {
          label: "Relances",
          title: "Relances",
          permissions: "dashboard application reminder"
        }
      },
      {
        path: "/admin/accompagnes/:status",
        component: AttendantList,
        name: "attendant-list",
        meta: {
          label: "Accompagnés",
          title: "Accompagnés",
          permissions: "dashboard application attendant"
        }
      },
      {
        path: "/admin/documents/:document/edit",
        component: EditDocument,
        name: "edit-document",
        meta: {
          label: "Edition",
          title: "Editer le document",
          permissions: "create document"
        }
      },
      {
        path: "/admin/documents/new",
        component: EditDocument,
        name: "new-document",
        meta: {
          title: "Nouveau document",
          label: "Ajouter",
          permissions: "create document"
        }
      },
      {
        name: "import-dates",
        component: ImportTrainingDates,
        path: "/admin/trainings/dates/import",
        meta: {
          title: "Import",
          label: "Importer des dates",
          permissions: "edit training_dates"
        },
      },
      {
        name: "import-capacities",
        component: ImportTrainingCapacities,
        path: "/admin/trainings/capacities/import",
        meta: {
          title: "Import",
          label: "Importer des capacités",
          permissions: "edit training_capacities"
        },
      },
      {
        path: "/admin/training/:trainingId/edit",
        component: EditTraining,
        name: "edit-training",
        meta: {
          label: "Edition",
          title: "Editer la formation",
          permissions: "edit training"
        }
      },

      {
        path: "/admin/training/new",
        component: EditTraining,
        name: "new-training",
        meta: {
          title: "Nouvelle formation",
          label: "Ajouter",
          permissions: "create training"
        }
      },
      {
        path: "/admin/offers/:offerId/edit",
        component: EditOffer,
        name: "edit-offer",
        meta: {
          label: "Edition",
          title: "Editer l'offre",
          permissions: "list offers"
        }
      },
      {
        path: "/admin/offer/new",
        component: EditOffer,
        name: "new-offer",
        meta: {
          title: "Nouvelle offre",
          label: "Ajouter",
          permissions: "create offer"
        }
      },
      {
        path: "/admin/offer/category/:category/edit",
        component: EditOfferCategory,
        name: "edit-offer-category",
        meta: {
          label: "Edition",
          title: "Modifier la catégorie"
        }
      },
      {
        path: "/admin/offer/category/new",
        component: EditOfferCategory,
        name: "new-offer-category",
        meta: {
          title: "Nouvelle catégorie",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/offer/promo-codes/:promo/edit",
        component: EditPromoCode,
        name: "edit-promo-code",
        meta: {
          title: "Modifier le code bourse",
          label: "Edition"
        }
      },
      {
        path: "/admin/offer/promo-codes/new",
        component: EditPromoCode,
        name: "new-promo-code",
        meta: {
          title: "Nouveau code bourse",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/registre",
        component: Stats,
        name: "stats",
        meta: {
          label: "Registre",
          title: "Registre",
          permissions: "access register"
        }
      },
      {
        path: "/admin/school/:school/edit",
        component: EditSchool,
        name: "edit-school",
        meta: {
          label: "Edition",
          title: "Modifier l'école"
        }
      },
      {
        path: "/admin/school/new",
        component: EditSchool,
        name: "new-school",
        meta: {
          title: "Nouvelle école",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/campus/:campus/edit",
        component: EditCampus,
        name: "edit-campus",
        meta: {
          label: "Edition",
          title: "Modifier le campus"
        }
      },
      {
        path: "/admin/campus/new",
        component: EditCampus,
        name: "new-campus",
        meta: {
          title: "Nouveau campus",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/event/:eventId/edit",
        component: EditEvent,
        name: "edit-event",
        meta: {
          label: "Edition",
          title: "Editer l'événement",
          permissions: "edit event"
        }
      },
      ...generateRoutesFromMenu(menuModule.state.items)
    ]
  },
  {
    path: "/admin/login",
    component: AdminConnection,
    name: "admin-connection"
  },
  {
    path: "/admissionsup/forgotpassword/:token",
    alias: "/admission/forgotpassword/:token",
    component: ResetPassword,
    name: "reset",
    meta: {
      schoolType: 'highschool',
      hasMenu: false
    }
  },
  {
    path: "/admissionsco/forgotpassword/:token",
    alias: "/admissionboardingschool/forgotpassword/:token",
    component: ResetPassword,
    name: "school-reset",
    meta: {
      schoolType: 'boardingschool',
      hasMenu: false
    }
  },
  {
    path: "/admissioneschool/forgotpassword/:token",
    component: ResetPassword,
    name: "eschool-reset",
    meta: {
      schoolType: 'eschool',
      hasMenu: false
    }
  },
  {
    path: "/admissionsup",
    alias: "/admissions",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: Home,
        name: "highschool-list",
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/jpo/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Jpo,
        name: "jpo",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/atelier/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Atelier,
        name: "atelier",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/webinaire/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Webinaire,
        name: "webinaire",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/live/:school/",
    component: MainLayout,
    children: [
      {
        path: "",
        component: JpoLive,
        name: "live",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/documentation/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: JpoDoc,
        name: "documentation",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school/offres",
    alias: "/admission/:school/offres",
    component: MainLayout,
    meta: {
      schoolType: 'highschool'
    },
    children: [
      {
        path: "",
        component: EshopHome,
        name: "highschool-categories",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "sessions",
        component: EshopInternship,
        name: "highschool-internship",
        meta: {
          schoolType: 'highschool'
        }
      },
      {
        path: "categorie/:categoryId",
        component: EshopHome,
        name: "highschool-category",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "categorie/:categoryId/:offerId",
        component: EshopHome,
        name: "highschool-offer",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "paiement",
        component: EshopHome,
        name: "highschool-checkout",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "commande/:orderId",
        component: EshopHome,
        name: "highschool-order",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "connexion",
        component: EshopConnection,
        name: "connection-highschool",
        meta: {
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: EshopConnection,
        name: "registration-highschool",
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school/profil",
    alias: "/admission/:school/profil",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolProfile,
        name: "highschool-profile",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school",
    alias: "/admission/:school",
    component: MainLayout,
    meta: {
      schoolType: 'highschool'
    },
    children: [
      {
        path: "",
        component: HighSchoolApplication,
        name: "highschool-home",
        meta: {
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "mon-compte",
        component: HighSchoolApplication,
        name: "profile",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "procedure",
        component: Process,
        name: "process"
      },
      {
        path: "contrat",
        component: Contract,
        name: "contrat"
      },
      {
        path: "contact",
        component: Contact,
        name: "contact",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      },
      {
        path: "connexion",
        component: Connection,
        name: "highschool-connection",
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: Registration,
        name: "highschool-registration",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      },
      {
        path: '404',
        alias: '*',
        component: NotFoundPage,
        name: "highschool-not-found"
      }
    ]
  },

  // Eschool routes
  {
    path: "/admissioneschool/:school/offres",
    component: MainLayout,
    meta: {
      schoolType: 'eschool'
    },
    children: [
      {
        path: "",
        component: EshopHome,
        name: "eshop-categories",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "sessions",
        component: EshopInternship,
        name: "eshop-internship",
        meta: {
          schoolType: 'eschool'
        }
      },
      {
        path: "categorie/:categoryId",
        component: EshopHome,
        name: "eshop-category",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "categorie/:categoryId/:offerId",
        component: EshopHome,
        name: "eshop-offer",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "paiement",
        component: EshopHome,
        name: "eshop-checkout",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "commande/:orderId",
        component: EshopHome,
        name: "eshop-order",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "connexion",
        component: EshopConnection,
        name: "connection-eshop",
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissioneschool/:school/profil",
    alias: "/admissioneschool/:school/profil",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolProfile,
        name: "eschool-profile",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      }
    ]
  },

  {
    path: "/admissioneschool",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolHome,
        name: "eschool",
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissioneschool/:school",
    component: MainLayout,
    meta: {
      schoolType: 'eschool'
    },
    children: [
      {
        path: "",
        component: EschoolApplication,
        name: "eschool-home",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "mon-compte",
        component: EschoolApplication,
        name: "eschool-application",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "procedure",
        component: Process,
        name: "eschool-process"
      },
      {
        path: "contrat",
        component: EschoolContract,
        name: "eschool-contrat"
      },
      {
        path: "contact/:campus",
        component: Contact,
        name: "eschool-contact",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
      },
      {
        path: "connexion",
        component: Connection,
        name: "eschool-connection",
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: Registration,
        name: "eschool-registration",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      },
      {
        path: '404',
        alias: '*',
        component: NotFoundPage,
        name: "eschool-not-found"
      }
    ]
  },


    // BoardingSchool routes
  {
    path: "/admissionsco/:school/offres",
    alias: "/admissionboardingschool/:school/offres",
    component: MainLayout,
    meta: {
      schoolType: 'boardingschool'
    },
    children: [
      {
        path: "",
        component: ShopHome,
        name: "shop-categories",
        meta: {
          schoolType: 'boardingschool',
        }
      },
      {
        path: "stages",
        component: ShopInternship,
        name: "shop-internship",
        meta: {
          schoolType: 'boardingschool'
        }
      },
      {
        path: "categorie/:categoryId",
        component: ShopHome,
        name: "shop-category",
        meta: {
          schoolType: 'boardingschool',
        }
      },
      {
        path: "categorie/:categoryId/:offerId",
        component: ShopHome,
        name: "shop-offer",
        meta: {
          schoolType: 'boardingschool',
        }
      },
      {
        path: "paiement",
        component: ShopHome,
        name: "shop-checkout",
        meta: {
          schoolType: 'boardingschool',
        }
      },
      {
        path: "commande/:orderId",
        component: ShopHome,
        name: "shop-order",
        meta: {
          schoolType: 'boardingschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "connexion",
        component: ShopConnection,
        name: "connection-shop",
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsco/:school/profil",
    alias: "/admissionboardingschool/:school/profil",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: SchoolProfile,
        name: "school-profile",
        meta: {
          schoolType: 'boardingschool',
          isCandidate: true,
          requiresAuth: true
        }
      }
    ]
  },

  {
    path: "/admissionsco",
    alias: "/admissionboardingschool",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: SchoolHome,
        name: "boardingschool-home",
        meta: {
          schoolType: 'boardingschool',
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsco/:school",
    alias: "/admissionboardingschool/:school",
    component: MainLayout,
    meta: {
      schoolType: 'boardingschool'
    },
    children: [
      {
        path: "",
        component: SchoolApplication,
        name: "school-home",
        meta: {
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "mon-compte",
        component: SchoolApplication,
        name: "school-application",
        meta: {
          schoolType: 'boardingschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "procedure",
        component: Process,
        name: "school-process"
      },
      {
        path: "contrat",
        component: SchoolContract,
        name: "school-contrat"
      },
      {
        path: "contact/:campus",
        component: Contact,
        name: "school-contact",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      },
      {
        path: "connexion",
        component: Connection,
        name: "school-connection",
        meta: {
          schoolType: 'boardingschool',
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: Registration,
        name: "school-registration",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          schoolType: 'boardingschool',
          hasMenu: false
        }
      },
      {
        path: '404',
        alias: '*',
        component: NotFoundPage,
        name: "boardingschool-not-found"
      }
    ]
  },


];

// Vue Router Configuration
const router = new VueRouter({
  mode: "history",
  routes,
  // Bulma Active Class
  linkExactActiveClass: "is-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 500);
      });
    }
  }
});

EventBus.$on("error:401", () => {
  const account = store.getters["auth/getAccount"];

  if (account.roles && account.roles.includes("admin")) {
    store.dispatch("auth/logout");
    router.replace({ path: "/admin/login" });
  }

  if (account.roles && account.roles.includes("candidate")) {
    const route = router.currentRoute;
    store.dispatch("auth/logout");
    if (route.params.school) {
      if (
        route.params.school === "france" ||
        route.params.school === "suisse"
      ) {
        if (route.name.startsWith("shop")) {
          router.replace({
            path:
              "/admissionsco/" +
              route.params.school +
              "/offres/connexion"
          });
        } else {

          router.replace({
            path:
              "/admissionsco/" + route.params.school + "/connexion"
          });
        }
      } else {
        if (route.params.school === "eschool") {
          if (route.name.startsWith("eshop")) {
            router.replace({
              path:
                  "/admissioneschool/" +
                  route.params.school +
                  "/offres/connexion"
            });
          }else{
            router.replace({
              path: "/admissionsco/" + route.params.school + "/connexion"
            });
          }

        }else{
          router.replace({
            path: "/admissionsup/" + route.params.school + "/connexion"
          });
        }
      }
    } else {
      router.replace({ path: "/admissionsup" });
    }
  }
});

// Hooks
router.beforeEach((to, from, next) => {
  const { body } = document;
  const WIDTH = 768;
  const RATIO = 3;

  const handler = () => {
    if (!document.hidden) {
      const rect = body.getBoundingClientRect();
      const isMobile = rect.width - RATIO < WIDTH;
      store.dispatch("toggleDevice", isMobile ? "mobile" : "other");
      store.dispatch("toggleSidebar", {
        opened: !isMobile
      });
    }
  };

  document.addEventListener("visibilitychange", handler);
  window.addEventListener("DOMContentLoaded", handler);
  window.addEventListener("resize", handler);
  handler();

  /*if (to.matched.some(m => m.meta.isAdmin)) {
    store.dispatch("auth/checkAccount");
    return api.checkIsAdmin().then(response => {
      if (
          response.status !== 200 ||
          !response.data.user.roles.includes("admin") ||
          !store.getters["auth/isLoggedIn"]
      ) {
        store.dispatch("auth/logout");
        return next({ path: "/admin/login" });
      }
      return next();
    });
  }*/
  if (to.matched.some(m => m.meta.isAdmin)) {
    return api.checkIsAdmin().then(response => {

      if (response && response.status === 200) {
        //EventBus.$off('APPOINTMENT_CALL');
        EventBus.$emit('APPOINTMENT_CALL', response.data.user);
        store.commit('auth/setRefreshedAccount', response.data.user)
      }

      if (
        (response && response.status !== 200) ||
        !response.data.user.roles.includes("admin") ||
        !store.getters["auth/isLoggedIn"]
      ) {
        store.dispatch("auth/logout");
        return next({ path: "/admin/login", query: { redirect: to.fullPath } });
      }
      const account = store.getters["auth/getAccount"];
      next();
      if (
        account.can &&
        !account.can[to.meta.permissions] &&
        !account.roles.includes("superadmin")
      ) {
        return next({
          name: "Dashboard"
        });
      }
      return next();
    });
  }
  if (to.matched.some(m => m.meta.isCandidate)) {
    /*if (to.params.school) {

      if (to.params.school === "france" || to.params.school === "suisse") {
        if (to.name.startsWith("shop")) {
          router.replace({
            path:
                "/admissionboardingschool/" +
                to.params.school +
                "/offres/connexion"
          });
        } else {
          router.replace({
            path:
                "/admissionboardingschool/" + to.params.school + "/connexion"
          });
        }
      } else {
        if (to.params.school === "eschool") {
          router.replace({
            path: "/admissioneschool/" + to.params.school + "/connexion"
          });
        }else{
          router.replace({
            path: "/admission/" + to.params.school + "/connexion"
          });
        }

      }
    } else {
      return next({ path: "/admissions" });
    }*/

    return api.checkIsAdmin().then(response => {
      if (
        response &&
        (response.status !== 200 ||
          response.data.user.roles.includes("admin") ||
          !store.getters["auth/isLoggedIn"])
      ) {
        store.dispatch("auth/logout");
        if (to.params.school) {

          if (to.params.school === "france" || to.params.school === "suisse") {
            if (to.name.startsWith("shop")) {
              router.replace({
                path:
                  "/admissionsco/" +
                  to.params.school +
                  "/offres/connexion"
              });
            } else {
              router.replace({
                path:
                  "/admissionsco/" + to.params.school + "/connexion"
              });
            }
          } else {
            if (to.params.school === "eschool") {
              router.replace({
                path: "/admissioneschool/" + to.params.school + "/connexion"
              });
            }else{
              router.replace({
                path: "/admissionsup/" + to.params.school + "/connexion"
              });
            }

          }
        } else {
          return next({ path: "/admissionsup" });
        }
      }
      return next();
    });
  }

  return next();
});

// Menu should have 2 levels.
function generateRoutesFromMenu(menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    const item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

export default router;
